import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import { TextWrap } from "../../util/showmore";
import * as constants from "./constants";
import { GetCallProgess } from "./GetCallProgress";
import { Timer } from "./Timer";

export const MuteAction = (props) => {
  const dispatch = useDispatch();
  const MUTE_STATE = useSelector((state) => {
    return state.ticker[constants.CALL_COMMANDS.MUTE];
  });

  return (
    <>
      {props.callFlow.isSipCall() && (
        <span className="mute-call click-icon">
          <a
            href="/#"
            onClick={(e) => {
              e.preventDefault();
              MUTE_STATE === constants.MUTE_STATES.NOT_ON_MUTE
                ? props.callFlow.callAction(
                    constants.CALL_COMMANDS.MUTE,
                    { value: constants.MUTE_STATES.ON_MUTE },
                    dispatch
                  )
                : props.callFlow.callAction(
                    constants.CALL_COMMANDS.MUTE,
                    { value: constants.MUTE_STATES.NOT_ON_MUTE },
                    dispatch
                  );
            }}
          >
            {MUTE_STATE !== constants.MUTE_STATES.ON_MUTE && (
              <img
                alt=""
                className="mute-call-icon"
                src={toAbsoluteUrl("/media/sr/icons/mute.svg")}
              />
            )}

            {MUTE_STATE === constants.MUTE_STATES.ON_MUTE && (
              <img
                alt=""
                className="mute-call-icon"
                src={toAbsoluteUrl("/media/sr/icons/mute-active.svg")}
              />
            )}
          </a>
        </span>
      )}
    </>
  );
};

export const HoldAction = (props) => {
  const dispatch = useDispatch();
  const HOLD_STATE = useSelector((state) => {
    return state.ticker[constants.CALL_COMMANDS.HOLD];
  });

  return (
    <>
      <span className="pause-call click-icon">
        <a
          href="/#"
          onClick={(e) => {
            e.preventDefault();
            HOLD_STATE === constants.HOLD_STATES.ON_UNHOLD
              ? props.callFlow.callAction(
                  constants.CALL_COMMANDS.HOLD,
                  { value: constants.HOLD_STATES.ON_HOLD },
                  dispatch
                )
              : props.callFlow.callAction(
                  constants.CALL_COMMANDS.HOLD,
                  { value: constants.HOLD_STATES.ON_UNHOLD },
                  dispatch
                );
          }}
        >
          {HOLD_STATE === constants.HOLD_STATES.ON_HOLD && (
            <img
              alt=""
              className="pause-call-icon"
              src={toAbsoluteUrl("/media/sr/icons/pause-active.svg")}
            />
          )}
          {HOLD_STATE !== constants.HOLD_STATES.ON_HOLD && (
            <img
              alt=""
              className="pause-call-icon"
              src={toAbsoluteUrl("/media/sr/icons/pause.svg")}
            />
          )}
        </a>
      </span>
    </>
  );
};

export const LiveCallMinimized = (props) => {
  const handleClose = () => {};

  const dispatch = useDispatch();

  return (
    <div className="d-flex justify-content-between align-items-center add-conference-header">
      <div className="header-content">
        <div className="number-sec">
          <div className="head-sec-title">
            <TextWrap
              text={props.callFlow.getCustomerName()}
              max={props.isMobile ? 11 : 14}
            />
            {props.callFlow.state.view_state ==
              constants.CALL_VIEW_STATES.CALL_TRANSFER_CONNECTED_VIEW &&
              props.callFlow.state.callInitialEvent &&
              props.callFlow.state.callInitialEvent.variable_sticky_agent ===
                "1" && (
                <span className="ml-1">
                  <img
                    alt=""
                    style={{
                      verticalAlign: "top",
                      borderStyle: "none",
                      height: "22px",
                      marginTop: "-4px",
                    }}
                    className="sticky-ag "
                    src={toAbsoluteUrl("/media/sr/icons/sticky-agent.svg")}
                  />
                </span>
              )}
          </div>
          <div className="head-sec-detail">
            {props.callFlow.getCustomerNumber()}
          </div>
        </div>
      </div>
      {!props.type && (
        <div className="conference-header-actions action-content d-flex">
          {!props.disableProgress && (
            <div className="call-timer-sec mr-3">
              <div className="head-sec-title">
                <GetCallProgess />:
              </div>
              <div className="head-sec-detail">
                <Timer disableSymbols={props.disableSymbols} />
              </div>
            </div>
          )}
          <HoldAction {...props} />
          <MuteAction {...props} />
          {props.callFlow.isSipCall() && (
            <span className="disconnect-call click-icon" onClick={handleClose}>
              <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  props.callFlow.callDisconnect(dispatch);
                }}
              >
                <img
                  alt=""
                  className="disconnect-call-icon"
                  src={toAbsoluteUrl("/media/sr/icons/disconnect-call.svg")}
                />
              </a>
            </span>
          )}
        </div>
      )}

      {props.type === "call_transfer_completed" && <></>}
    </div>
  );
};
